import React, { useState, useEffect } from 'react';
import { withStyles, IconButton, Tooltip} from '@material-ui/core';
import styles from './styles';
import { del, get, handleResponse, swal500 } from '../../../utils/network';
import { useHistory, useLocation } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Visibility } from '@material-ui/icons';


const UserAccessGroupsComponent = ({
    classes,
    values
}) => {

    const history = useHistory();
    const [ accessGroups, setAccessGroups ] = useState([]);

    

    useEffect(() => {
        const getAccessGroups = ()=>{
            get('groups')
                .then( res => handleResponse(res, { history }) )
                .then( data => {
                    setAccessGroups(data.message.data)
                })
        }
        getAccessGroups()
    }, [history])

    const checkGroup = (group) => {
        const groupFound = accessGroups.find(g => g.group === group)
        console.log(groupFound)

        return 
        
    }

    return (
        <>
            <p className={classes.sectionTitle} style={{ marginTop: 10 }}>
                Grupos de Entra ID: 
            </p>
            { !values.entraId ? 
                <p>No se encontraron grupos registrados de Entra ID</p> 
            : 
            <TableContainer component={Paper}>
                <Table size="small" style={{maxWidth:'35rem'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Grupos</TableCell>
                            <TableCell align="right">Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.entraId.groups
                            .filter((group, index) => {
                                return accessGroups.find(g => g.entraIdGroupId === group)
                            })
                            .map((group, index) => {
                                const groupFound = accessGroups.find(g => g.entraIdGroupId === group)
                                const redirect = id => history.push(`/home/accessGroups/${id || 'new'}`);

                                return (
                                    <TableRow key={group}>
                                        <TableCell component="th" scope="row"> <span>{group}</span> </TableCell>
                                        <TableCell align="right">
                                            {groupFound && 
                                                <Tooltip title="Ver grupo de acceso">
                                                    <IconButton onClick={() => redirect(groupFound._id)}>
                                                        <Visibility />
                                                    </IconButton>
                                                </Tooltip>
                                            }

                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </>
    );
};

export default withStyles(styles)(UserAccessGroupsComponent)